<template>
  <div class="select-box" :class="{ 'small': isSmall ,  'member-change': memberChange }">
    <select class="select" :class="{ 'member': memberChange,'no-border': isNoBorder}" :value="selectedOption" @change="handleSelectChange" @click.stop>
      <option value v-if="placeholder != ''">{{placeholder}}</option>
      <template v-for="option in options">
        <option
          :key="option.id"
          :value="option.id"
        >
          {{option.name}}
        </option>
      </template>
    </select>
  </div>
</template>

<script>
export default {
  name: 'LabelSelectBox',

  props: {
    options: {
      type: Array,
      default: () => [],
    },
    selectedOption: {
      type: [String, Number],
    },
    placeholder: {
      type: String,
      default: '',
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    memberChange: {
      type: Boolean,
      default: false,
    },
    isNoBorder: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleSelectChange(e) {
      this.$emit('handleSelectChange', e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.select-box{
  position: relative;
  display: flex;
  width: 100%;
  background-color: $white;
  border-radius: 6px;
  &:before{
    content: '';
    position: absolute;
    // z-index: 2;
    top: 12px;
    right: 7px;
    width: 0;
    height: 0;
    border: 4px dashed;
    border-color: $black transparent;
    pointer-events: none;
    border-bottom-style: solid;
    border-top: none;
  }
  .select{
    position: relative;
    width: 100%;
    // padding-left: 20px;
    margin: 0;
    font-size: 14px;
    height: 40px;
    text-shadow: 0 1px white;
    background: transparent !important;
    border: solid 1px #B0AEAE;
    border-radius: 0;
    outline: none;
    cursor: pointer;
    color: #6d6c6c;
    text-align: center;
    text-align-last: center;
    &.no-border {
      border: none;
    }
    &.member{
      text-align: start;
      text-align-last: start;
      padding: 4px 10px;
      border-radius: 8px;
    }
  }
  &:after{
    content: '';
    position: absolute;
    // z-index: 2;
    top: 20px;
    right: 7px;
    width: 0;
    height: 0;
    border: 4px dashed;
    color: $black;
    border-color: $black transparent;
    pointer-events: none;
    margin-top: 7px;
    border-top-style: solid;
    border-bottom: none;
  }
}
@media screen and (max-width: $tabletWidth) {
  .small.select-box {
    .select {
      height: 25px;
    }
    &:before{
      top: 6px;
    }
    &:after{
      top: 6px;
    }
  }
}
</style>
